module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "tipo": _vm.TIPO_CONTRATO.PRESTADOR
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativas")])])])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_vm._v("Recarregar PDF "), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Escalas por Unidade",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, _vm._l((_vm.dataTable.data), function(unidade, index) {
    return _c('table', {
      key: index,
      staticClass: "table table-bordered",
      attrs: {
        "role": "grid"
      }
    }, [_c('thead', [_c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('th', [_vm._v("Unidade: " + _vm._s(unidade.nome))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(unidade.profissionais && unidade.profissionais.length == 0) ? _c('td', [_c('h4', [_vm._v("Nenhum profissional encontrado!")])]) : _vm._e()]), _vm._v(" "), _vm._l((unidade.profissionais), function(profissional, index) {
      return _c('tr', {
        key: index,
        staticClass: "even",
        attrs: {
          "role": "row"
        }
      }, [_c('td', [_c('table', {
        staticClass: "table table-bordered table-striped",
        attrs: {
          "role": "grid"
        }
      }, [_c('thead', [_c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('th', {
        attrs: {
          "colspan": "5"
        }
      }, [_vm._v("Profissional: " + _vm._s(profissional.nome) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('tbody', [_c('tr', [(profissional.contrato_procedimento_atendimentos && profissional.contrato_procedimento_atendimentos.length == 0) ? _c('td', {
        attrs: {
          "colspan": "5"
        }
      }, [_c('h4', [_vm._v("Nenhum procedimento encontrado!")])]) : _vm._e()]), _vm._v(" "), _vm._l((profissional.contrato_procedimento_atendimentos), function(agenda, index) {
        return _c('tr', {
          key: index,
          staticClass: "even",
          attrs: {
            "role": "row"
          }
        }, [_c('td', {
          staticStyle: {
            "width": "60%"
          }
        }, [_vm._v(_vm._s(agenda.contrato_procedimento.procedimento.codigo) + " - " + _vm._s(agenda.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm._f("dia")(agenda.dia)))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(agenda.hora_inicial) + " às " + _vm._s(agenda.hora_final))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(agenda.quantidade_primeira))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(agenda.quantidade_retorno))])])
      })], 2)])])])
    })], 2)])
  })), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tMostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")])])]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Escalas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Agenda")]), _vm._v(" "), _c('th', [_vm._v("Dia")]), _vm._v(" "), _c('th', [_vm._v("Horário")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Retorno")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-009ae4f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/escalas/index.vue
// module id = 781
// module chunks = 0